// @owners { team: patients }
import { type PriceType } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { useCallback } from 'react';
import { initializeNewOrder } from '~shared/actions/checkout';
import { useCartData } from '~shared/features/cart/hooks/useCartData';
import type { ItemKey } from '~shared/features/checkout/types';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useDispatchShared, useSelectorShared } from '~shared/store';

export const useInitializeNewOrder = () => {
  const { cartItems } = useCartData();
  const dispatch = useDispatchShared();
  const isEditOrder = useSelectorShared(getIsEditingExistingOrder);

  const initializeCartItems = useCallback(() => {
    if (isEditOrder) return;

    const items: ItemKey[] = cartItems.map((item) => ({
      resource_id: item.resource_id,
      resource_type: item.resource_type as 'Prescription',
    }));
    const selected_payment_types = cartItems.reduce<Record<number, PriceType>>((acc, item) => {
      if (item.selected_price_type) {
        acc[item.resource_id] = item.selected_price_type;
      }
      return acc;
    }, {});
    const autoRefills = cartItems.reduce<Record<number, boolean>>((acc, item) => {
      if (item.auto_refill_enabled !== undefined) {
        acc[item.resource_id] = item.auto_refill_enabled;
      }
      return acc;
    }, {});
    dispatch(initializeNewOrder(items, selected_payment_types, autoRefills));
  }, [cartItems, dispatch, isEditOrder]);

  return { initializeCartItems };
};
